module.exports = __webpack_public_path__ + "static/img/6.4bb6c144.png";